import {
  age,
  createGroupCountFields,
  gender,
  generateVoteModeCountFields,
  GEO_TYPE_OPTIONS,
  GEO_TYPE_OPTIONS_MAPPING,
  maritalStatus,
  modeledParty,
  race,
  registeredParty,
  urbanicity,
  voterScore,
  voteSimilarPriorElection,
  voteModePriorElection,
} from "../../helpers/config";

const TITLE = "2024";
const DATA_FOLDER = "g2024";
const FINAL_EAV_COUNT_PREFIX = "final_eav_voted_count_";
const CURRENT_EAV_COUNT_PREFIX = "current_eav_voted_count_";
const FINAL_EDAY_COUNT_PREFIX = "final_eday_voted_count_";
const REGISTERED_COUNT_PREFIX = "registered_count_";
const TS_MODELED_PARTY_COUNT_FIELD = "count_cy";

const COUNT_PREFIXES = {
  REGISTERED_COUNT_PREFIX: REGISTERED_COUNT_PREFIX,
  FINAL_EAV_COUNT_PREFIX: FINAL_EAV_COUNT_PREFIX,
  CURRENT_EAV_COUNT_PREFIX: CURRENT_EAV_COUNT_PREFIX,
  FINAL_EDAY_COUNT_PREFIX: FINAL_EDAY_COUNT_PREFIX,
  TS_COUNT_PREFIX: "count_",
};
const YEAR_LABELS = ["2020", "2022", "2024"];
const YEARS = ["cyminus2", "cyminus1", "cy"];
const YEAR_MAPPING = Object.assign(
  ...YEARS.map((k, i) => ({ [k]: YEAR_LABELS[i] }))
);
let COUNT_FIELDS = createGroupCountFields(YEARS, COUNT_PREFIXES);

let VOTE_MODE_CATEGORIES = [
  "in_person_early",
  "absentee",
  "on_eday",
  "registered_didnt_vote",
  "unregistered",
];

let VOTE_MODE_COUNT_FIELDS = generateVoteModeCountFields(YEARS);

const DEMOGRAPHIC_MAPPING = {
  modeledParty: "party_score_rollup",
  registeredParty: "party_rollup",
  voterScore: "voterbase_voter_score",
  age: "age_bucket",
  race: "race",
  gender: "voterbase_gender",
  urbanicity: "urbanicity",
  maritalStatus: "marital_status",
  voteSimilarPriorElection: "vote_similar_prior_election",
  voteModePriorElection: "vote_mode_prior_election",
};

const DEMOGRAPHIC_OPTIONS = [
  { label: "Gender", value: gender },
  { label: "Modeled Party", value: modeledParty },
  { label: "Registered Party", value: registeredParty },
  { label: "Vote Frequency", value: voterScore },
  { label: "Age", value: age },
  { label: "Race", value: race },
  { label: "Marital Status", value: maritalStatus },
  { label: "Urbanicity", value: urbanicity },
  { label: "Voted in 2020", value: voteSimilarPriorElection },
  { label: "Vote Mode 2020", value: voteModePriorElection },
];

// This is a backup list of state options for G2024, in case dynamicStateOptions are unavailable.
const states = [
  { label: "Alaska", value: "AK" },
  { label: "Arkansas", value: "AR" },
  { label: "Arizona", value: "AZ" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Iowa", value: "IA" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Maryland", value: "MD" },
  { label: "Montana", value: "MT" },
  { label: "North Carolina", value: "NC" },
  { label: "New Jersey", value: "NJ" },
  { label: "New York", value: "NY" },
  { label: "Ohio", value: "OH" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "Virginia", value: "VA" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
];

const YEAR_COLORS = [
  "#cfdeef",
  "#457b9d",
  "#1e3556",
  "#ff8075",
  "#ee3526",
  "#99150a",
];

const isCurrent = false;
let config = {
  TITLE: TITLE,
  states: states,
  DEMO_OPTIONS: DEMOGRAPHIC_OPTIONS,
  DEMOGRAPHIC_MAPPING: DEMOGRAPHIC_MAPPING,
  YEARS: YEARS,
  YEAR_COLORS: YEAR_COLORS,
  COUNT_FIELDS: COUNT_FIELDS,
  VOTE_MODE_COUNT_FIELDS: VOTE_MODE_COUNT_FIELDS,
  COUNT_PREFIXES: COUNT_PREFIXES,
  VOTE_MODE_CATEGORIES: VOTE_MODE_CATEGORIES,
  GEO_TYPE_OPTIONS_MAPPING: GEO_TYPE_OPTIONS_MAPPING,
  GEO_TYPE_OPTIONS: GEO_TYPE_OPTIONS,
  TS_MODELED_PARTY_COUNT_FIELD: TS_MODELED_PARTY_COUNT_FIELD,
  DATA_FOLDER: DATA_FOLDER,
  YEAR_LABELS: YEAR_LABELS,
  YEAR_MAPPING: YEAR_MAPPING,
  isCurrent: isCurrent,
};
export { config };
